import React from 'react';
import CallAnimation from '../chat_overlay/outgoin_call/call_animation';
import classes from './classes.module.scss';
import VoipControls from './voip_controls';
import { renderNameAndDiscountLabel } from './voip_utils';
import Const from '../../config/const';
import { getModeColor } from '../../config/util';

function VoiceOverlay({
  profilePictureUrl,
  discountData,
  t,
  voipType,
  name,
  timerEvents = {}
}) {
  return (
    <div className={ classes.voiceContainer }>
      <img
        className={ classes.backgroundImage }
        src={ profilePictureUrl }
        alt=""
      />
      <div className={ classes.voiceOverlay } />
      <div className={ classes.callAnimation }>
        <CallAnimation
          pictureSrc={ profilePictureUrl }
          borderColor={ getModeColor(Const.chatTypeToModeName[voipType]) }
        />
        {renderNameAndDiscountLabel({
          voipType, discountData, name, t
        })}
      </div>
      <VoipControls
        timerEvents={ timerEvents }
      />
    </div>
  );
}

export default VoiceOverlay;
